import { render, staticRenderFns } from "./AdminRecruiter.vue?vue&type=template&id=08bf1b00&"
import script from "./AdminRecruiter.vue?vue&type=script&lang=js&"
export * from "./AdminRecruiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports